const vapewholesalehub = {
    id: 'vapewholesalehub',
    publicSiteName: 'Vape Wholesale Hub',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#cd7200',
            secondary: '#111111',
            color1: '#f48b07',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapewholesalehub/favicon.ico',
        logo: '/vapewholesalehub/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default vapewholesalehub